export default __webpack_public_path__ + "static/media/36I-102747_-17350_0.3e2c6d74.jpg";